"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconContainer = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var IconContainer = exports.IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-8qkwwp-0"
})(["align-items:center;border-radius:50%;display:flex;block-size:48px;justify-content:center;margin-block:0 ", ";margin-inline:auto;inline-size:48px;background-color:", ";"], (0, _index.cssSpacing)('base', '16px'), (0, _index.cssColorValue)('backgroundBase'));